import Versions from '@/api/versions/versions.js'
import fileDownload from 'js-file-download'
import router from '@/router'

const versions = new Versions()

const versionsModule = {
  namespaced: true,
  state: {
    items: [],
    item: null,
    lookups: [],
    experimentsLookups: [],
    subExperimentsLookups: [],
    total: 0,
    load: false,
    loadItem: false,
    statusLookups: [],
  },
  getters: {
    experimentsLookups(state) {
      return state.experimentsLookups
    },
    items(state) {
      return state.items
    },
    item(state) {
      return state.item
    },
    load(state) {
      return state.load
    },
    loadItem(state) {
      return state.loadItem
    },
    total(state) {
      return state.total
    },
    statusLookups(state) {
      return state.statusLookups
    },
    lookups(state) {
      return state.lookups
    },
    // subExperimentsLookups(state) {
    //   return state.subExperimentsLookups;
    // },
  },
  mutations: {
    SET_EXPERIMENTS_LOOKUPS(state, experimentsLookups) {
      state.experimentsLookups = experimentsLookups
    },
    SET_ITEMS: (state, experiments) => {
      state.items = experiments
    },
    SET_STATUS_LOOKUPS: (state, statusLookups) => {
      state.statusLookups = statusLookups
    },
    SET_TOTAL_EXPERIMENTS: (state, total) => {
      state.total = total
    },
    SET_ITEMS_LOAD: (state, load) => {
      state.load = load
    },
    SET_ITEM: (state, school) => {
      state.item = school
    },
    SET_LOAD_ITEM: (state, loadItem) => {
      state.loadItem = loadItem
    },
    SET_LOOKUPS(state, lookups) {
      state.lookups = lookups
    },
    SET_SUBEXPERIMENTS_LOOKUPS(state, lookups) {
      state.subExperimentsLookups = lookups
    },
  },
  actions: {
    list({ commit }, query) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEMS_LOAD', true)
        versions.list(query).then(response => {
          commit('SET_ITEMS', response)
          commit('SET_TOTAL_EXPERIMENTS', response.meta.total)
          commit('SET_ITEMS_LOAD', false)
          resolve(response)
        })
      })
    },
    put({ commit }, payload) {
      return new Promise((resolve, reject) => {
        versions
          .put(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    update({ commit }, payload) {
      return new Promise((resolve, reject) => {
        versions
          .update(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    statusLookups({ commit }) {
      return new Promise((resolve, reject) => {
        versions.statusLookups().then(response => {
          commit('SET_STATUS_LOOKUPS', response.data)
          resolve(response)
        })
      })
    },
    get({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_ITEM', true)
        versions
          .get(id)
          .then(response => {
            commit('SET_ITEM', response.data)
            commit('SET_LOAD_ITEM', false)
            resolve(response)
          })
          .catch(error => {
            reject(error)
            commit('SET_LOAD_ITEM', false)
          })
      })
    },
    remove({ commit }, id) {
      return new Promise((resolve, reject) => {
        versions
          .remove(id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    restore({ commit }, id) {
      return new Promise((resolve, reject) => {
        versions
          .restore(id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

  },
}

export default versionsModule
